module.exports = require('./helpers/bundle-url').getBundleURL('ad4mF') + "logo.c51670a8.svg";